import { useCallback } from "react";

export const useFormData = () => {
  const getFormData = useCallback((data: any, categoryId?: string) => {
    const request: any = {
      ...data,
      fileId:
        data.file && data.file.length > 0 ? data.file[0].response : undefined,
    };

    if (categoryId) {
      request.categoryId = categoryId;
    }

    delete request.file;

    return request;
  }, []);

  return { getFormData };
};
